import { useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
import LoginModal from './LoginModal';
// import { useUserStore } from '../../store';
import { ROUTES } from '../../routes';
import './index.scss';

// 获取 URL 参数
const getQueryParams = () => {
  const params = new URLSearchParams(window.location.search);
  return {
    redirect: params.get('redirect'),
    ae: params.get('ae'),
  };
};

export default function Login() {
  // const navigate = useNavigate();
  // const isRegistered = useUserStore((state) => state.isRegistered);

  // 获取 URL 中的 ae 参数并存入 localStorage
  useEffect(() => {
    const { ae } = getQueryParams();
    if (ae) {
      localStorage.setItem('ae_invite_code', ae);
    }
  }, []);

  const handleLoginSuccess = () => {
    const { redirect } = getQueryParams();

    if (redirect) {
      window.location.href = decodeURIComponent(redirect);
    } else {
      window.location.href = ROUTES.dashboard;
    }
  };

  const handleClose = () => {
    window.location.href = ROUTES.home;
  };

  return (
    <div className="login-page">
      <LoginModal onClose={handleClose} onLoginSuccess={handleLoginSuccess} />
    </div>
  );
}
